import { globalVariable } from '@/utils/exportVariable'

export function getUserAgent() {
  if (process.client) {
    return window.navigator.userAgent || window.navigator.vendor || window.opera
  }

  const { context } = globalVariable

  if (!context?.req?.headers) {
    return ''
  }

  return context.req.headers['user-agent'] || ''
}

export function getLocation(locations, showLog) {
  if (process.client) return window.location
  if (locations && locations.host && locations.url) {
    return new URL(locations.url, `https://${locations.host}`)
  }

  const { context } = globalVariable
  /* eslint-disable */
  showLog && console.log('context ===>>>', +new Date(), context)

  const defaultLocation = {
    href: '',
    protocol: '',
    host: '',
    hostname: '',
    port: '',
    pathname: '',
    search: '',
    hash: '',
    username: '',
    password: '',
    origin: '',
  }

  if (!context?.req?.url) {
    return defaultLocation
  }

  try {
    // const url = new URL(context.req.url.replace(/\/+/, '/'), `http://${context.req.headers.host}`)
    const detectedHost =
      context.req.headers['x-forwarded-host'] || context.req.headers.host
    const url = new URL(
      context.req.url.replace(/\/+/, '/'),
      `https://${detectedHost}`
    )
    /* eslint-disable */
    showLog &&
      console.log(
        'x-forwarded-host ===>>>',
        context.req.headers['x-forwarded-host']
      )
    /* eslint-disable */
    showLog && console.log('host ===>>>', context.req.headers.host)
    /* eslint-disable */
    showLog && console.log('detectedHost ===>>>', detectedHost, url)

    const {
      href,
      protocol,
      host,
      hostname,
      port,
      pathname,
      search,
      hash,
      username,
      password,
      origin,
    } = url

    return {
      href,
      protocol,
      host,
      hostname,
      port,
      pathname,
      search,
      hash,
      username,
      password,
      origin,
    }
  } catch (e) {
    return defaultLocation
  }
}

export function getNavigatorLang() {
  if (process.client) return window.navigator.language

  const { context } = globalVariable

  if (!context?.req?.headers || !context.req.headers['accept-language']) {
    return 'en_US'
  }

  try {
    return context.req.headers['accept-language'].split(',')[0]
  } catch (e) {
    return 'en_US'
  }
}
